<template>
    <rkm-layout-body title="Lista de especialidade">
        <template v-slot:actions>
            <rkm-button
                @click="$refs.ModalAtribuicao.open()"
                authorize="store-cadastro-especialidade"
                color="info"
            >
                Atribuição de parâmetro por CBO/Especialidade
            </rkm-button>

            <rkm-button
                @click="$router.push({name: 'cadastro-especialidade-create'})"
                authorize="store-cadastro-especialidade"
                color="primary"
            >
                Cadastrar especialidade
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>

        <ModalAtribuicao ref="ModalAtribuicao" />
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/cadastro/especialidade/List'
import ModalAtribuicao from '@/components/cadastro/especialidade/components/atribuicao/Modal'

export default {
    components: {List, ModalAtribuicao},
}
</script>